<template>
  <brb-modal
    ref="brb-modal"
    title="قرارداد"
    centered
    size="lg"
    no-close-on-backdrop
    no-activator
  >
    <b-overlay class="p-4" style="white-space: pre-line">
      {{ $t('account.conditions') }}
    </b-overlay>
    <template #footer>
      <div class="d-flex justify-content-center p-4">
        <brb-btn
          class="py-2 text-center"
          variant="brb-secondary"
          @click="submitTermsAndConditions"
        >
          {{ $t('shared.accept') }}
        </brb-btn>
      </div>
    </template>
  </brb-modal>
</template>

<script>
export default {
  name: 'ActionRequiredModal',
  data() {
    return {
      model: {}
    }
  },
  methods: {
    show() {
      this.$refs['brb-modal'].show()
    },
    submitTermsAndConditions() {
      this.loading = true
      this.$api.driverAccount
        .confirmContract()
        .then(() => {
          this.$showSuccess(this.$t('message.success.acceptConditions'))
          this.$refs['brb-modal'].hide()
        })
        .catch((error) => this.$showError(error.toString()))
        .finally(() => (this.loading = false))
    }
  }
}
</script>
